/*
 * Despacho Express (Flapp) — colección filtrada por tienda con cobertura real.
 *
 * Flujo:
 *   1. El cliente ingresa su dirección (Google Places o fallback manual).
 *   2. Se consulta la cobertura a Flapp (directo a public-rates o vía proxy propio,
 *      según settings de la sección).
 *   3. El cliente elige una tienda disponible y el grid se filtra usando el
 *      atributo data-flapp-locations que cada card trae desde el metafield
 *      custom.inventory_locations (regla: quantity > 0).
 *
 * La selección persiste en localStorage con TTL y se revalida en segundo plano.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'flapp:despacho:v1';
  const CACHE_PREFIX = 'flapp:avail:';
  const CACHE_TTL_MS = 10 * 60 * 1000;
  const MAX_EXTRA_PAGES = 10;
  const FETCH_TIMEOUT_MS = 15000;

  /* Lista de comunas para el autocompletado del fallback manual (sin Google Maps). */
  const COMUNAS = ["Algarrobo","Alhue","Alto Biobio","Alto Del Carmen","Ancud","Andacollo","Angol","Antartica","Antofagasta","Antuco","Arauco","Arica","Aysen","Buin","Bulnes","Cabildo","Cabo de Hornos","Cabrero","Calama","Calbuco","Caldera","Calera de Tango","Calle Larga","Camarones","Camina","Canela","Canete","Carahue","Cartagena","Casablanca","Castro","Catemu","Cauquenes","Cerrillos","Cerro Navia","Chaiten","Chanaral","Chanco","Chepica","Chiguayante","Chile Chico","Chillan","Chillan Viejo","Chimbarongo","Chol Chol","Chonchi","Cobquecura","Cochamo","Cochrane","Codegua","Coelemu","Coihueco","Coinco","Colbun","Colchane","Colina","Collipulli","Coltauco","Combarbala","Concepcion","Conchali","Concon","Constitucion","Contulmo","Copiapo","Coquimbo","Coronel","Corral","Coyhaique","Cunco","Curacautin","Curacavi","Curaco de Velez","Curanilahue","Curarrehue","Curepto","Curico","Dalcahue","Diego de Almagro","Donihue","El Bosque","El Carmen","El Monte","El Quisco","El Tabo","Empedrado","Ercilla","Estacion Central","Florida","Freire","Freirina","Fresia","Frutillar","Futaleufu","Futrono","Galvarino","General Lagos","Gorbea","Graneros","Guaitecas","Hijuelas","Hualaihue","Hualane","Hualpen","Hualqui","Huara","Huasco","Huechuraba","Illapel","Independencia","Iquique","Isla de Maipo","Isla de Pascua","Juan Fernandez","La Calera","La Cisterna","La Cruz","La Estrella","La Florida","La Granja","La Higuera","La Ligua","La Pintana","La Reina","La Serena","La Union","Lago Ranco","Lago Verde","Laguna Blanca","Laja","Lampa","Lanco","Las Cabras","Las Condes","Lautaro","Lebu","Licanten","Limache","Linares","Litueche","Llanquihue","Llay Llay","Lo Barnechea","Lo Espejo","Lo Prado","Lolol","Loncoche","Longavi","Lonquimay","Los Alamos","Los Andes","Los Angeles","Los Lagos","Los Muermos","Los Sauces","Los Vilos","Lota","Lumaco","Machali","Macul","Mafil","Maipu","Malloa","Marchigue","Maria Elena","Maria Pinto","Mariquina","Maule","Maullin","Mejillones","Melipeuco","Melipilla","Molina","Monte Patria","Mulchen","Nacimiento","Nancagua","Navidad","Negrete","Ninhue","Niquen","Nogales","Nueva Imperial","Nunoa","Ohiggins","Olivar","Ollague","Olmue","Osorno","Ovalle","Padre Hurtado","Padre Las Casas","Paiguano","Paillaco","Paine","Palena","Palmilla","Panguipulli","Panquehue","Papudo","Paredones","Parral","Pedro Aguirre Cerda","Pelarco","Pelluhue","Pemuco","Penaflor","Penalolen","Pencahue","Penco","Peralillo","Perquenco","Petorca","Peumo","Pica","Pichidegua","Pichilemu","Pinto","Pirque","Pitrufquen","Placilla Sexta Region","Portezuelo","Porvenir","Pozo Almonte","Primavera","Providencia","Puchuncavi","Pucon","Pudahuel","Puente Alto","Puerto Cisnes","Puerto Montt","Puerto Natales","Puerto Octay","Puerto Varas","Pumanque","Punitaqui","Punta Arenas","Puqueldon","Puren","Purranque","Putaendo","Putre","Puyehue","Queilen","Quellon","Quemchi","Quilaco","Quilicura","Quilleco","Quillon","Quillota","Quilpue","Quinchao","Quinta Normal","Quinta de Tilcoco","Quintero","Quirihue","Rancagua","Ranquil","Rauco","Recoleta","Renaico","Renca","Rengo","Requinoa","Retiro","Rinconada","Rio Bueno","Rio Claro","Rio Hurtado","Rio Ibanez","Rio Negro","Rio Verde","Romeral","Saavedra","Sagrada Familia","Salamanca","San Antonio","San Bernardo","San Carlos","San Clemente","San Esteban","San Fabian","San Felipe","San Fernando","San Francisco de Mostazal","San Gregorio","San Ignacio","San Javier","San Joaquin","San Jose de Maipo","San Juan de La Costa","San Miguel","San Nicolas","San Pablo","San Pedro","San Pedro de Atacama","San Pedro de La Paz","San Rafael","San Ramon","San Rosendo","San Vicente de Tagua Tagua","Santa Barbara","Santa Cruz","Santa Juana","Santa Maria","Santiago Centro","Santo Domingo","Sierra Gorda","Talagante","Talca","Talcahuano","Taltal","Temuco","Teno","Teodoro Schmidt","Tierra Amarilla","Til Til","Timaukel","Tirua","Tocopilla","Tolten","Tome","Torres Del Paine","Tortel","Traiguen","Trehuaco","Tucapel","Valdivia","Vallenar","Valparaiso","Vichuquen","Victoria","Vicuna","Vilcun","Villa Alegre","Villa Alemana","Villarrica","Vina Del Mar","Vitacura","Yerbas Buenas","Yumbel","Yungay","Zapallar"];

  const stripAccents = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '');

  function normalizeCommune(name) {
    let c = stripAccents(String(name || '').trim().toLowerCase());
    if (c === 'santiago centro') c = 'santiago';
    return c;
  }

  const formatCLP = (n) =>
    typeof n === 'number' && isFinite(n) ? '$' + Math.round(n).toLocaleString('es-CL') : null;

  function fetchJSON(url, options, timeoutMs) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs || FETCH_TIMEOUT_MS);
    return fetch(url, Object.assign({ signal: controller.signal }, options)).finally(() =>
      clearTimeout(timer)
    );
  }

  class FlappDespacho extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.config = {
        mode: this.dataset.endpointMode || 'public',
        endpoint: (this.dataset.endpoint || 'https://api.weflapp.com').replace(/\/+$/, ''),
        posId: parseInt(this.dataset.posId, 10) || 0,
        mapsKey: (this.dataset.mapsKey || '').trim(),
        ttlMs: (parseInt(this.dataset.ttlMinutes, 10) || 45) * 60 * 1000,
        totalPages: parseInt(this.dataset.totalPages, 10) || 1,
        collectionUrl: this.dataset.collectionUrl || window.location.pathname,
        storePrefix: this.dataset.storePrefix || '',
        excludedStores: (this.dataset.excludedStores || '').split(/[\s,;]+/).filter(Boolean),
        hideEmptyStores: this.dataset.hideEmptyStores === 'true',
        /* Selectores del tema anfitrión (defaults = Impact). Permiten usar el
           mismo asset en temas con otra estructura de colección (ej. Concept). */
        gridSelector: this.dataset.gridSelector || '.product-list',
        resultsSelector: this.dataset.resultsSelector || '.collection__results',
        paginationSelector: this.dataset.paginationSelector || '.collection__pagination',
        dimSelector: this.dataset.dimSelector || '.collection',
      };

      this.sectionRoot = this.closest('[id^="shopify-section-"]') || document.body;
      this.address = null;
      this.stores = [];
      this.selectedStore = null;
      this._pagesLoaded = null;

      this._bindElements();
      this._bindEvents();
      this._initAddressInput();
      this._observeGridReplacement();
      this._restore();
    }

    /* ------------------------------------------------------------------ */
    /* Setup                                                              */
    /* ------------------------------------------------------------------ */

    _bindElements() {
      const $ = (name) => this.querySelector('[data-flapp-el="' + name + '"]');
      this.els = {
        gate: $('gate'),
        addressInput: $('address-input'),
        mapsSlot: $('maps-slot'),
        manualFields: $('manual-fields'),
        communeInput: $('commune-input'),
        submitBtn: $('submit'),
        gateMsg: $('gate-msg'),
        picker: $('picker'),
        pickerList: $('picker-list'),
        pickerAddress: $('picker-address'),
        pickerClose: $('picker-close'),
        overlay: $('overlay'),
        sticky: $('sticky'),
        stickyStore: $('sticky-store'),
        stickyAddress: $('sticky-address'),
        stickyCount: $('sticky-count'),
        changeStoreBtn: $('change-store'),
        changeAddressBtn: $('change-address'),
        empty: $('empty'),
        emptyAddress: $('empty-address'),
        retryBtn: $('retry'),
      };
    }

    _bindEvents() {
      this.els.submitBtn?.addEventListener('click', () => this._onSubmitAddress());
      this.els.addressInput?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this._onSubmitAddress();
        }
      });
      this.els.pickerClose?.addEventListener('click', () => this._closePicker());
      this.els.overlay?.addEventListener('click', () => this._closePicker());
      this.els.changeStoreBtn?.addEventListener('click', () => this._reopenPicker());
      this.els.changeAddressBtn?.addEventListener('click', () => this._changeAddress());
      this.els.retryBtn?.addEventListener('click', () => this._changeAddress());
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this._closePicker();
      });
    }

    _setState(state) {
      this.state = state;
      const gateLike = state === 'gate' || state === 'checking' || state === 'empty';
      this.sectionRoot.classList.toggle('flapp-state-gate', gateLike);
      this.sectionRoot.classList.toggle('flapp-state-active', state === 'active');
      this.sectionRoot.querySelector(this.config.dimSelector)?.classList.toggle('flapp-dimmed', gateLike);
      this.els.gate?.classList.toggle('flapp-hidden', state === 'active' || state === 'empty');
      this.els.empty?.classList.toggle('flapp-hidden', state !== 'empty');
      this.els.sticky?.classList.toggle('flapp-hidden', state !== 'active');
      if (this.els.submitBtn) {
        this.els.submitBtn.classList.toggle('flapp-loading', state === 'checking');
        this.els.submitBtn.disabled = state === 'checking';
      }
    }

    _message(text, kind) {
      if (!this.els.gateMsg) return;
      this.els.gateMsg.textContent = text || '';
      this.els.gateMsg.dataset.kind = kind || 'info';
      this.els.gateMsg.classList.toggle('flapp-hidden', !text);
    }

    /* ------------------------------------------------------------------ */
    /* Dirección: Google Places con fallback manual                        */
    /* ------------------------------------------------------------------ */

    _initAddressInput() {
      if (!this.config.mapsKey) {
        this._enableManualMode();
        return;
      }

      this._loadMaps()
        .then(() => {
          const places = window.google && window.google.maps && window.google.maps.places;
          if (places && places.Autocomplete) {
            this._attachClassicAutocomplete();
          } else if (places && places.PlaceAutocompleteElement) {
            this._attachPlaceAutocompleteElement();
          } else {
            this._enableManualMode();
          }
        })
        .catch(() => this._enableManualMode());
    }

    _loadMaps() {
      if (window.google && window.google.maps && window.google.maps.places) return Promise.resolve();
      if (window.__flappMapsPromise) return window.__flappMapsPromise;

      window.__flappMapsPromise = new Promise((resolve, reject) => {
        window.__flappMapsCallback = () => resolve();
        const script = document.createElement('script');
        script.src =
          'https://maps.googleapis.com/maps/api/js?key=' +
          encodeURIComponent(this.config.mapsKey) +
          '&libraries=places&language=es&region=CL&loading=async&callback=__flappMapsCallback';
        script.async = true;
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return window.__flappMapsPromise;
    }

    _attachClassicAutocomplete() {
      const input = this.els.addressInput;
      if (!input) return;
      const ac = new window.google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: 'cl' },
        fields: ['address_components', 'geometry', 'formatted_address'],
        types: ['address'],
      });
      ac.addListener('place_changed', () => {
        const place = ac.getPlace();
        if (!place || !place.address_components) return;
        this._setAddressFromComponents(place.address_components, place.geometry, place.formatted_address);
      });
    }

    _attachPlaceAutocompleteElement() {
      const slot = this.els.mapsSlot;
      if (!slot) {
        this._enableManualMode();
        return;
      }
      try {
        const el = new window.google.maps.places.PlaceAutocompleteElement({
          includedRegionCodes: ['cl'],
        });
        el.classList.add('flapp-gate__maps-element');
        this.els.addressInput?.classList.add('flapp-hidden');
        slot.appendChild(el);
        el.addEventListener('gmp-select', async (event) => {
          try {
            const place = event.placePrediction.toPlace();
            await place.fetchFields({ fields: ['addressComponents', 'location', 'formattedAddress'] });
            const components = (place.addressComponents || []).map((c) => ({
              long_name: c.longText,
              short_name: c.shortText,
              types: c.types,
            }));
            const geometry = place.location
              ? { location: { lat: () => place.location.lat, lng: () => place.location.lng } }
              : null;
            this._setAddressFromComponents(components, geometry, place.formattedAddress);
          } catch (err) {
            this._message(this.dataset.textErrorGeneric, 'error');
          }
        });
      } catch (err) {
        this._enableManualMode();
      }
    }

    _setAddressFromComponents(components, geometry, formatted) {
      const get = (type) => {
        const c = components.find((comp) => comp.types.indexOf(type) !== -1);
        return c ? c.long_name : '';
      };
      const streetNumber = get('street_number');
      const route = get('route');
      const commune = get('administrative_area_level_3') || get('locality') || get('sublocality_level_1') || get('sublocality');

      if (!route) {
        this._message(this.dataset.textNeedStreet, 'warn');
        return;
      }
      if (!streetNumber) {
        this.address = null;
        this._message(this.dataset.textNeedNumber, 'warn');
        return;
      }

      let latitude = null;
      let longitude = null;
      if (geometry && geometry.location) {
        latitude = typeof geometry.location.lat === 'function' ? geometry.location.lat() : geometry.location.lat;
        longitude = typeof geometry.location.lng === 'function' ? geometry.location.lng() : geometry.location.lng;
      }

      this.address = {
        address1: (route + ' ' + streetNumber).trim(),
        commune: normalizeCommune(commune),
        latitude: latitude,
        longitude: longitude,
        formatted: formatted || route + ' ' + streetNumber + ', ' + commune,
      };
      this._message('', 'info');
      this._onSubmitAddress();
    }

    _enableManualMode() {
      this.manualMode = true;
      this.els.manualFields?.classList.remove('flapp-hidden');
      const datalist = this.querySelector('#flapp-communes');
      if (datalist && !datalist.children.length) {
        const fragment = document.createDocumentFragment();
        COMUNAS.forEach((c) => {
          const option = document.createElement('option');
          option.value = c;
          fragment.appendChild(option);
        });
        datalist.appendChild(fragment);
      }
    }

    _onSubmitAddress() {
      if (this.manualMode) {
        const address1 = (this.els.addressInput?.value || '').trim();
        const commune = normalizeCommune(this.els.communeInput?.value || '');
        if (!address1 || !/\d/.test(address1)) {
          this._message(this.dataset.textNeedNumber, 'warn');
          return;
        }
        if (!commune) {
          this._message(this.dataset.textNeedCommune, 'warn');
          return;
        }
        this.address = { address1: address1, commune: commune, latitude: null, longitude: null, formatted: address1 + ', ' + commune };
      }

      if (!this.address) {
        this._message(this.dataset.textNeedAddress, 'warn');
        return;
      }
      this._checkAvailability(this.address);
    }

    /* ------------------------------------------------------------------ */
    /* Disponibilidad (Flapp)                                              */
    /* ------------------------------------------------------------------ */

    async _checkAvailability(address, options) {
      const silent = options && options.silent;
      if (!silent) {
        this._setState('checking');
        this._message(this.dataset.textChecking, 'info');
      }

      let stores;
      try {
        stores = await this._fetchAvailability(address);
      } catch (err) {
        if (silent) return;
        this._setState('gate');
        this._message(this.dataset.textErrorGeneric, 'error');
        return;
      }

      this.stores = stores;

      if (silent) {
        const stillAvailable = this.selectedStore && stores.some((s) => s.stockSourceId === this.selectedStore.stockSourceId);
        if (!stillAvailable) {
          this._clearSaved();
          this._clearFilter();
          this._setState('gate');
          this._message(this.dataset.textSelectionExpired, 'warn');
        }
        return;
      }

      if (!stores.length) {
        this._setState('empty');
        if (this.els.emptyAddress) this.els.emptyAddress.textContent = address.formatted || '';
        return;
      }

      this._message('', 'info');
      await this._openPicker(stores);
    }

    async _fetchAvailability(address) {
      const cacheKey =
        CACHE_PREFIX +
        this.config.mode +
        ':' +
        address.commune +
        ':' +
        (address.latitude != null ? address.latitude.toFixed(3) + ',' + address.longitude.toFixed(3) : 'nolatlng');

      /* La exclusión se aplica después de la caché para que cambios del
         setting en el editor apliquen de inmediato. */
      const applyExclusions = (stores) =>
        stores.filter((s) => this.config.excludedStores.indexOf(String(s.stockSourceId)) === -1);

      try {
        const cached = JSON.parse(sessionStorage.getItem(cacheKey));
        if (cached && Date.now() - cached.ts < CACHE_TTL_MS) return applyExclusions(cached.stores);
      } catch (err) {
        /* cache corrupta: se ignora */
      }

      const stores = this.config.mode === 'proxy'
        ? await this._fetchViaProxy(address)
        : await this._fetchViaPublicRates(address);

      try {
        sessionStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), stores: stores }));
      } catch (err) {
        /* storage lleno: se ignora */
      }
      return applyExclusions(stores);
    }

    async _fetchViaPublicRates(address) {
      const body = {
        pointOfSaleId: this.config.posId,
        shippingAddress: {
          address1: address.address1,
          commune: address.commune,
        },
        items: [],
      };
      if (address.latitude != null && address.longitude != null) {
        body.shippingAddress.latitude = address.latitude;
        body.shippingAddress.longitude = address.longitude;
      }

      const response = await fetchJSON(this.config.endpoint + '/integrations/generic/public-rates', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (!response.ok) throw new Error('public-rates HTTP ' + response.status);
      const rates = await response.json();
      if (!Array.isArray(rates)) throw new Error('public-rates: respuesta inesperada');

      /* Puede venir más de una tarifa por local (incluso duplicadas): se
         consolida por stockSourceId quedándose con el menor precio. */
      const byStore = new Map();
      rates.forEach((rate) => {
        const local = rate.Local || {};
        const id = local.stockSourceId;
        if (!id) return;
        const priceInfo = rate.selectedDeliveryRatePrice || {};
        const price = [priceInfo.price, priceInfo.minPrice].find((v) => typeof v === 'number');
        const openingHours = (local.OpeningHours && local.OpeningHours[0]) || {};
        const cutoff = openingHours.limitTimes && openingHours.limitTimes[rate.shippingType];
        const entry = {
          stockSourceId: String(id),
          name: this._displayStoreName(local.name || id),
          shippingType: rate.shippingType || 'express',
          price: typeof price === 'number' ? price : null,
          cutoff: cutoff ? String(cutoff).slice(0, 5) : null,
          commune: local.address && local.address.commune,
        };
        const existing = byStore.get(entry.stockSourceId);
        if (!existing || (entry.price != null && (existing.price == null || entry.price < existing.price))) {
          byStore.set(entry.stockSourceId, entry);
        }
      });
      return Array.from(byStore.values());
    }

    async _fetchViaProxy(address) {
      const response = await fetchJSON(this.config.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ address: address }),
      });
      if (!response.ok) throw new Error('proxy HTTP ' + response.status);
      const data = await response.json();
      if (!data || !Array.isArray(data.stores)) throw new Error('proxy: respuesta inesperada');
      return data.stores.map((s) => ({
        stockSourceId: String(s.stockSourceId),
        name: this._displayStoreName(s.name || s.stockSourceId),
        shippingType: s.shippingType || 'express',
        price: typeof s.price === 'number' ? s.price : null,
        cutoff: s.cutoff || null,
        commune: s.commune || null,
      }));
    }

    _displayStoreName(name) {
      const prefix = this.config.storePrefix;
      let clean = String(name);
      if (prefix && clean.toLowerCase().startsWith(prefix.toLowerCase())) {
        clean = clean.slice(prefix.length).trim();
      }
      return clean || name;
    }

    /* ------------------------------------------------------------------ */
    /* Carga de páginas adicionales (colecciones > 50 productos)           */
    /* ------------------------------------------------------------------ */

    _productList() {
      return this.sectionRoot.querySelector(this.config.gridSelector);
    }

    _cards() {
      return Array.from(
        this.sectionRoot.querySelectorAll(this.config.gridSelector + ' [data-flapp-locations]')
      );
    }

    _ensureAllPagesLoaded() {
      if (this._pagesLoaded) return this._pagesLoaded;

      /* Los merges se serializan: si un cambio de facets invalida la carga
         mientras otra sigue en vuelo, la nueva espera a la anterior en vez de
         correr en paralelo (evita duplicados por carrera). */
      const previous = this._mergeChain || Promise.resolve();
      const promise = previous.then(() => this._mergePages());
      this._pagesLoaded = promise;
      this._mergeChain = promise.catch(() => {});
      return promise;
    }

    /* Identidad de una card para deduplicar: URL del producto sin query. */
    _cardKey(card) {
      const link = card.querySelector('a[href*="/products/"]');
      return link ? (link.getAttribute('href') || '').split('?')[0] : null;
    }

    async _mergePages() {
      const totalPages = Math.min(this.config.totalPages, 1 + MAX_EXTRA_PAGES);
      if (totalPages <= 1) return;
      const list = this._productList();
      if (!list) return;
      this._merging = true;

      try {
        const requests = [];
        for (let page = 2; page <= totalPages; page++) {
          const url = new URL(this.config.collectionUrl, window.location.origin);
          new URLSearchParams(window.location.search).forEach((value, key) => {
            if (key !== 'page') url.searchParams.set(key, value);
          });
          url.searchParams.set('page', String(page));
          requests.push(
            fetchJSON(url.toString(), { headers: { Accept: 'text/html' } })
              .then((r) => (r.ok ? r.text() : ''))
              .catch(() => '')
          );
        }

        const pagesHtml = await Promise.all(requests);
        const parser = new DOMParser();
        /* Se parte del contenido ya presente para que un merge redundante
           (p. ej. re-disparado por el observer) agregue exactamente 0 cards. */
        const seen = new Set(this._cards().map((card) => this._cardKey(card)).filter(Boolean));

        pagesHtml.forEach((html) => {
          if (!html) return;
          const doc = parser.parseFromString(html, 'text/html');
          doc.querySelectorAll(this.config.gridSelector + ' [data-flapp-locations]').forEach((card) => {
            const key = this._cardKey(card);
            if (key) {
              if (seen.has(key)) return;
              seen.add(key);
            }
            list.appendChild(document.adoptNode(card));
          });
        });

        this.sectionRoot.querySelector(this.config.paginationSelector)?.classList.add('flapp-hidden');
      } finally {
        /* Los callbacks del MutationObserver corren como microtask: liberar el
           flag en un macrotask garantiza que las mutaciones de ESTE merge aún
           se vean marcadas como propias y no re-disparen otra carga. */
        setTimeout(() => {
          this._merging = false;
        }, 0);
      }
    }

    /* ------------------------------------------------------------------ */
    /* Selector de tiendas                                                 */
    /* ------------------------------------------------------------------ */

    async _openPicker(stores) {
      await this._ensureAllPagesLoaded();

      const counts = this._countProductsByStore();
      let enriched = stores
        .map((store) => Object.assign({}, store, { productCount: counts[store.stockSourceId] || 0 }))
        .sort((a, b) => b.productCount - a.productCount || (a.price || 0) - (b.price || 0));

      if (this.config.hideEmptyStores) {
        enriched = enriched.filter((store) => store.productCount > 0);
      }

      if (!enriched.length) {
        this._setState('empty');
        if (this.els.emptyAddress) this.els.emptyAddress.textContent = this.address?.formatted || '';
        return;
      }

      if (this.els.pickerAddress) this.els.pickerAddress.textContent = this.address?.formatted || '';
      this._renderPickerList(enriched);
      this.els.picker?.classList.add('is-open');
      this.els.overlay?.classList.add('is-open');
      document.body.classList.add('flapp-no-scroll');
      this._setState(this.selectedStore ? 'active' : 'gate');
    }

    _renderPickerList(stores) {
      const list = this.els.pickerList;
      if (!list) return;
      list.innerHTML = '';

      stores.forEach((store) => {
        const disabled = store.productCount === 0;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'flapp-picker__store';
        button.disabled = disabled;
        if (this.selectedStore && this.selectedStore.stockSourceId === store.stockSourceId) {
          button.classList.add('is-selected');
        }

        const price = formatCLP(store.price);
        const metaParts = [];
        if (price) metaParts.push((this.dataset.textFrom || 'Desde') + ' ' + price);
        if (store.cutoff) metaParts.push((this.dataset.textCutoff || 'Pide antes de las') + ' ' + store.cutoff);

        const countText = disabled
          ? this.dataset.textNoProducts || 'Sin productos disponibles'
          : store.productCount + ' ' + (this.dataset.textProductsAvailable || 'productos disponibles');

        button.innerHTML =
          '<span class="flapp-picker__store-main">' +
          '<span class="flapp-picker__store-name"></span>' +
          '<span class="flapp-picker__store-meta"></span>' +
          '</span>' +
          '<span class="flapp-picker__store-count"></span>';
        button.querySelector('.flapp-picker__store-name').textContent = store.name;
        button.querySelector('.flapp-picker__store-meta').textContent = metaParts.join(' · ');
        button.querySelector('.flapp-picker__store-count').textContent = countText;

        if (!disabled) button.addEventListener('click', () => this._selectStore(store));
        list.appendChild(button);
      });
    }

    _closePicker() {
      this.els.picker?.classList.remove('is-open');
      this.els.overlay?.classList.remove('is-open');
      document.body.classList.remove('flapp-no-scroll');
    }

    async _reopenPicker() {
      if (!this.address) return;
      if (this.stores.length) {
        this._openPicker(this.stores);
      } else {
        await this._checkAvailability(this.address);
      }
    }

    /* ------------------------------------------------------------------ */
    /* Filtro del grid                                                     */
    /* ------------------------------------------------------------------ */

    _countProductsByStore() {
      const counts = {};
      this._cards().forEach((card) => {
        String(card.getAttribute('data-flapp-locations') || '')
          .split(/\s+/)
          .filter(Boolean)
          .forEach((id) => {
            counts[id] = (counts[id] || 0) + 1;
          });
      });
      return counts;
    }

    async _selectStore(store) {
      this.selectedStore = store;
      this._closePicker();
      await this._applyFilter();
      this._save();
      this._setState('active');
    }

    async _applyFilter() {
      if (!this.selectedStore) return;
      await this._ensureAllPagesLoaded();

      const id = this.selectedStore.stockSourceId;
      let visible = 0;
      this._cards().forEach((card) => {
        const match = String(card.getAttribute('data-flapp-locations') || '')
          .split(/\s+/)
          .indexOf(id) !== -1;
        card.classList.toggle('flapp-card-hidden', !match);
        if (match) visible++;
      });

      if (this.els.stickyStore) this.els.stickyStore.textContent = this.selectedStore.name;
      if (this.els.stickyAddress) this.els.stickyAddress.textContent = this.address?.formatted || '';
      if (this.els.stickyCount) {
        this.els.stickyCount.textContent =
          visible + ' ' + (this.dataset.textProductsAvailable || 'productos disponibles');
      }
    }

    _clearFilter() {
      this._cards().forEach((card) => card.classList.remove('flapp-card-hidden'));
      this.selectedStore = null;
    }

    _changeAddress() {
      this._clearSaved();
      this._clearFilter();
      this._closePicker();
      this._setState('gate');
      this.els.addressInput?.focus();
    }

    /* Los facets/sort de Impact reemplazan el grid vía AJAX: se re-aplica
       el filtro y la carga de páginas sobre el DOM nuevo. */
    _observeGridReplacement() {
      const results = this.sectionRoot.querySelector(this.config.resultsSelector) || this.sectionRoot;
      const observer = new MutationObserver(() => {
        if (this._merging || this.state !== 'active') return;
        clearTimeout(this._reapplyTimer);
        this._reapplyTimer = setTimeout(() => {
          this._pagesLoaded = null;
          this._applyFilter();
        }, 150);
      });
      observer.observe(results, { childList: true, subtree: true });
    }

    /* ------------------------------------------------------------------ */
    /* Persistencia                                                        */
    /* ------------------------------------------------------------------ */

    _save() {
      try {
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({ ts: Date.now(), address: this.address, store: this.selectedStore })
        );
      } catch (err) {
        /* storage no disponible */
      }
    }

    _clearSaved() {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (err) {
        /* noop */
      }
    }

    _restore() {
      let saved = null;
      try {
        saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
      } catch (err) {
        /* noop */
      }

      if (!saved || !saved.store || !saved.address || Date.now() - saved.ts > this.config.ttlMs) {
        this._clearSaved();
        this._setState('gate');
        return;
      }

      this.address = saved.address;
      this.selectedStore = saved.store;
      if (this.els.addressInput && this.address.formatted) this.els.addressInput.value = this.address.formatted;
      this._setState('active');
      this._applyFilter();
      this._checkAvailability(this.address, { silent: true });
    }
  }

  if (!customElements.get('flapp-despacho')) {
    customElements.define('flapp-despacho', FlappDespacho);
  }
})();
